import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NotificationBell from '../NotificationBell/NotificationBell';

/**
 * BottomTabBar — fixed bottom navigation for mobile/tablet (≤1024px).
 * Desktop is CSS-hidden; the existing sidebar is untouched.
 *
 * Props:
 *   onOpenMenu      — opens the existing full navigation drawer
 *   isAuthenticated — whether the current user is signed in
 *   isVisible       — false when user is scrolling down (auto-hide)
 */
const BottomTabBar = ({ onOpenMenu, isAuthenticated, isVisible }) => {
  const location = useLocation();

  // Returns true if any of the given path prefixes match the current location
  const isActive = (...paths) =>
    paths.some(
      (p) => location.pathname === p || location.pathname.startsWith(p + '/')
    );

  return (
    <nav
      className={`bottom-tab-bar${isVisible ? '' : ' bottom-tab-bar--hidden'}`}
      aria-label="Quick navigation"
    >
      {/* Home → News Feed */}
      <Link
        to="/news-feed"
        className={`btb-tab${isActive('/news-feed', '/') ? ' btb-tab--active' : ''}`}
      >
        <span className="btb-icon">🏠</span>
        <span className="btb-label">Home</span>
      </Link>

      {/* Amps */}
      <Link
        to="/amplifier_search"
        className={`btb-tab${isActive('/amplifier_search', '/amps') ? ' btb-tab--active' : ''}`}
      >
        <span className="btb-icon">🎸</span>
        <span className="btb-label">Amps</span>
      </Link>

      {/* Discuss */}
      <Link
        to="/discussions"
        className={`btb-tab${isActive('/discussions') ? ' btb-tab--active' : ''}`}
      >
        <span className="btb-icon">💬</span>
        <span className="btb-label">Discuss</span>
      </Link>

      {/* Notifications — NotificationBell handles badge + dropdown */}
      <div className="btb-tab btb-tab--notif">
        <NotificationBell tabBarMode />
      </div>

      {/* Profile */}
      <Link
        to={isAuthenticated ? '/profile' : '/login'}
        className={`btb-tab${isActive('/profile') ? ' btb-tab--active' : ''}`}
      >
        <span className="btb-icon">👤</span>
        <span className="btb-label">Profile</span>
      </Link>

      {/* Menu — opens the full slide-out navigation drawer */}
      <button
        className="btb-tab btb-tab--btn"
        onClick={onOpenMenu}
        aria-label="Open full navigation menu"
      >
        <span className="btb-icon">☰</span>
        <span className="btb-label">Menu</span>
      </button>
    </nav>
  );
};

export default BottomTabBar;
